/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';

const EmptyState = ({
  title,
  description,
  icon,
  action,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      py: '56px',
      px: '24px',
      textAlign: 'center',
    }}
  >
    <Box
      sx={{
        width: 72,
        height: 72,
        borderRadius: '50%',
        backgroundColor: '#F7FAFC',
        border: '1px solid #E2E8F0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mb: '20px',
        color: '#A0AEC0',
      }}
    >
      {icon || <InboxOutlinedIcon sx={{ fontSize: 32 }} />}
    </Box>

    <Typography
      sx={{
        fontSize: '16px',
        fontWeight: 600,
        color: '#2D3748',
        mb: description ? '8px' : '0px',
      }}
    >
      {title}
    </Typography>

    {description && (
      <Typography
        sx={{
          fontSize: '13px',
          color: '#718096',
          maxWidth: '360px',
          lineHeight: 1.6,
          mb: action ? '20px' : '0px',
        }}
      >
        {description}
      </Typography>
    )}

    {action && action}
  </Box>
);

EmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  icon: PropTypes.node,
  action: PropTypes.node,
};

export default EmptyState;
